import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'
import { setStorage } from '../api/storage';
// import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

Vue.prototype.getMessages = function() {
  return state.messages
}

const store = new Vuex.Store({
  actions,
  getters,
  state,
  mutations
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
})

store.watch(
  (state) => state.sessions,
  (val) => val ? setStorage(val) : setStorage([]), {
    deep: true
  }
)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js